var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"role":"main"}},[_c('Nav',{ref:"navigation_block"}),_vm._v(" "),_c('div',{staticClass:"text-center content main-content-root"},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }